var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroDecoration03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4714 32.3804C27.4398 31.8035 31.9523 27.811 32.3853 22.4598C32.7196 18.3079 35.5 0 35.5 0C35.5 0 37.8778 18.361 38.6223 22.4598C39.7086 28.5548 43.3323 31.6517 48.5362 32.3804C52.6536 32.9421 71 35.5 71 35.5C71 35.5 52.6764 38.0731 48.5362 38.6196C41.9269 39.4925 39.2604 43.7127 38.6223 48.5402C38.0677 52.6693 35.5 71 35.5 71C35.5 71 32.8031 52.6845 32.3701 48.5402C31.8079 42.9765 27.7436 39.2041 22.4714 38.612C18.3236 38.1566 0 35.4924 0 35.5C0 35.5 18.3236 32.8586 22.4714 32.3804Z",
    fill: "#FFCD05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroDecoration03);
export default __webpack_public_path__ + "static/media/hero-decoration-03.459a87b61fa7b5293e0fcde0f785033d.svg";
export { ForwardRef as ReactComponent };